function u(o, n = !0, r = !0) {
  const e = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }, t = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
  };
  if (o > 0) {
    n && (e.days = Math.floor(o / (1e3 * 60 * 60 * 24)), o -= e.days * (1e3 * 60 * 60 * 24)), e.hours = Math.floor(o / (1e3 * 60 * 60)), o -= e.hours * (1e3 * 60 * 60), e.minutes = Math.floor(o / (1e3 * 60)), o -= e.minutes * (1e3 * 60), e.seconds = Math.floor(o / 1e3), o -= e.seconds * 1e3;
    for (const s in e)
      e[s] < 10 ? t[s] = `0${e[s]}` : t[s] = e[s].toString();
  }
  return r ? n ? `${t.days}D : ${t.hours}H : ${t.minutes}M : ${t.seconds}S` : `${t.hours}H : ${t.minutes}M : ${t.seconds}S` : e;
}
function c(o, n = !0, r = !0, e = 0) {
  o instanceof Date && (o = o.getTime());
  const t = Math.max(o - (Date.now() + e), 0);
  return u(t, n, r);
}
const f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCountdownFromDuration: u,
  getCountdownFromTimestamp: c
}, Symbol.toStringTag, { value: "Module" }));
export {
  c as a,
  f as c,
  u as g
};
